import { dashboardHierarchyItemsSelector } from "./dashboardHierarchyItemsSelector";
import { RootState } from "../../../store";

export const dashboardsItemsCountSelector = (
  state: RootState,
): number | undefined => {
  const hierarchy = dashboardHierarchyItemsSelector(state);

  return hierarchy?.length;
};
